
const digest = 'e841388d709707df8b2d768fcf061f263aee016e25548e40cc1af07bc02047c6';
const classes = {"wrapper":"_wrapper_2t2fo_1"};
const css = `._wrapper_2t2fo_1 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  font-family: "Rubik", sans-serif;
  border-top: 1px solid #eaedf3;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  